import React, {useEffect, useState} from 'react'
import { Form } from 'antd'
import {TrialButton, StyledButtonContainer} from 'views/PreLogin/styled'
import useAxios from 'axios-hooks'
import {firstStepData, stepsDetails} from './data';

function DetailsStep({ form, setStep, setErrorMessage }) {
    const {getFieldDecorator} = form;
    
    const [
		{ data: validateAccountResponse, loading: validateAccountLoading, error: validateAccountError },
		fetchValidateAccount
	] = useAxios(
		{
			url: `/account/validate`,
			method: 'POST'
		},
		{ manual: true }
	)

    const onValidate = event => {
		event.preventDefault();
		form.validateFields().then((values) => {
            const { admin_first_name, admin_last_name, admin_email, admin_password, account_name, phone } = values
            fetchValidateAccount({ data: { admin_first_name, admin_last_name, admin_email, admin_password, account_name, phone }});
        });
	}
    
    useEffect(() => {
		if(validateAccountResponse){
			setStep(stepsDetails[1].name);
			setErrorMessage(null);
		}
		else if(validateAccountError){
			setErrorMessage(validateAccountError?.response?.data?.Errors);
		}
    }, [validateAccountResponse, validateAccountError])

	return (
		<div>			
            {
                firstStepData.map(item => (
                    <Form.Item>
                        {getFieldDecorator(item.name, {
                            validateTrigger: ['onChange', 'onBlur'],
                            rules: [
                                {
                                    required: !!item.ruleMsg,
                                    whitespace: true,
                                    message: item.ruleMsg
                                }
                            ]
                        })(item.children())}
                    </Form.Item>
                ))
            } 
            <StyledButtonContainer>
                <TrialButton 
                    onClick={onValidate}
                    size="large" 
                    type="primary" 
                    htmlType="submit" 
                >
                    NEXT
                </TrialButton>
			</StyledButtonContainer>
		</div>
	)
}
export default DetailsStep;
